import { Directive, ElementRef, OnInit } from '@angular/core';

/**
 * @description
 * Rc auto focus directive - focus on element once its loaded
 *
 * @example
 * <input type="text" lib-rc-autofocus />
 *
 */
@Directive({
  selector: '[lib-rc-autofocus]'
})
export class RcAutofocusDirective implements OnInit {

    /**
     * DOM element reference
     * @param ElementRef el
     */
  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    if (this.el) {
      this.el.nativeElement.tabIndex = 0;
      this.el.nativeElement.focus();
    }
  }
}
